import { isNullOrUndefined } from './StringUtil';

const monthNames: Array<string> = [
	'januar',
	'februar',
	'marts',
	'april',
	'maj',
	'juni',
	'juli',
	'august',
	'september',
	'oktober',
	'november',
	'december',
];

export const formatDate = (dateStr: string): string => {
	if (isNullOrUndefined(dateStr) || dateStr === '') {
		return '';
	}
	try {
		const date = dateStr.slice(0, 10);
		const dateFormatted = `${date.slice(8, 10)}.${date.slice(5, 7)}.${date.slice(2, 4)}`;
		if (dateFormatted.toLocaleLowerCase().includes('nan')) {
			return '';
		}
		return dateFormatted;
	} catch (err) {
		console.warn(err);
		return dateStr ? dateStr : '';
	}
};

export const buildDateSeparated = (dateStr: string): Array<string> => {
	const dateSeparated: Array<string> = [];
	if (isNullOrUndefined(dateStr) || dateStr === '') {
		return null;
	}
	try {
		const date = new Date(dateStr);

		dateSeparated.push(date.getDate() + '');
		dateSeparated.push(monthNames[date.getMonth()]);
		dateSeparated.push(date.getFullYear() + '');

		return dateSeparated;
	} catch (err) {
		console.warn(err);
		return null;
	}
};
